import { render, staticRenderFns } from "./RecStorageAddr.vue?vue&type=template&id=ef9c9834&scoped=true&"
import script from "./RecStorageAddr.vue?vue&type=script&lang=js&"
export * from "./RecStorageAddr.vue?vue&type=script&lang=js&"
import style0 from "./RecStorageAddr.vue?vue&type=style&index=0&id=ef9c9834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef9c9834",
  null
  
)

export default component.exports